export default "__VITE_ASSET__CHqbDPxz__"